var React = require('react');

function StatThreeThree (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.245116 15.8994C0.245117 7.61515 6.96085 0.899414 15.2451 0.899414C23.5294 0.899414 30.2451 7.61514 30.2451 15.8994L30.2451 122.542H0.245108L0.245116 15.8994Z","fill":"url(#paint0_linear_555_1760)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_555_1760","x1":"15.2451","y1":"0.899414","x2":"15.2451","y2":"122.542","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0.15625","stopColor":"#FFFCF3","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#FFFCF3","stopOpacity":"0","key":1})]))]);
}

StatThreeThree.defaultProps = {"width":"31","height":"123","viewBox":"0 0 31 123","fill":"none"};

module.exports = StatThreeThree;

StatThreeThree.default = StatThreeThree;
